import { LayoutWithSidebar } from 'utils/router/components/LayoutWithSidebar/LayoutWithSidebar'

export const RecurringNotificationTopicsRoutes = [
  {
    path: ':channel/recurring-notification-topics',
    Component: LayoutWithSidebar,
    children: [
      {
        index: true,
        lazy: () => import('./recurringNotificationTopics.page'),
      },
    ],
  },
] as const
